import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { useSidebar } from '../context/SidebarContext';

const Layout = ({ children, title }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const { collapsed, toggleCollapse } = useSidebar();

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      toggleCollapse();
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <Sidebar
        open={mobileOpen}
        onClose={handleDrawerToggle}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapse}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          // Un flex item trae min-width: auto, o sea que no baja del ancho
          // intrinseco de su contenido. Sin esto, una tabla con minWidth
          // estira el main y deforma toda la pagina en vez de scrollear
          // dentro de su propio TableContainer.
          minWidth: 0,
          backgroundColor: 'background.default',
          // En desktop, ajustar margen izquierdo para el sidebar
          marginLeft: { xs: 0, md: collapsed ? '64px' : '280px' },
          transition: 'margin-left 0.3s ease',
        }}
      >
        {/* Navbar */}
        <Navbar
          onMenuClick={handleDrawerToggle}
          title={title}
          collapsed={collapsed}
        />

        {/* Page Content */}
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            mt: '64px', // Height of AppBar
            p: { xs: 2, sm: 3 },
            backgroundColor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
